import { HeadingMedium, useStyletron } from "@mezo-org/mezo-clay"

import {
  selectIsConnected,
  selectUsername,
  useDappSelector,
} from "#/redux-state"

export default function OverviewWelcomeMessage() {
  const isConnected = useDappSelector(selectIsConnected)
  const mezoId = useDappSelector(selectUsername)
  const [, theme] = useStyletron()

  if (!isConnected || !mezoId) return null

  return (
    <HeadingMedium marginBottom={theme.sizing.scale1000}>
      Welcome {mezoId}.mezo
    </HeadingMedium>
  )
}
